// Shared ordering for recommendation lists (repo/Delivery + feature/Discovery pages).
// Surfaces high-impact recommendations first, then lower effort; mirrors the
// rank-map pattern used by GAP_SEVERITY_ORDER in ./gaps.ts.

const IMPACT_RANK: Record<string, number> = { high: 3, medium: 2, low: 1 };
const EFFORT_RANK: Record<string, number> = { low: 1, medium: 2, high: 3 };

/**
 * Sort comparator: impact descending (high first), then effort ascending
 * (low effort first) as a tie-breaker, then numeric `priority` ascending
 * (lower priority number = more urgent). Stable for ties so callers keep
 * their original order (e.g. dimension order on the feature page).
 */
export function compareRecommendations(
  a: { impact?: string; effort?: string; priority?: number },
  b: { impact?: string; effort?: string; priority?: number },
): number {
  const byImpact = (IMPACT_RANK[b.impact ?? ''] ?? 0) - (IMPACT_RANK[a.impact ?? ''] ?? 0);
  if (byImpact !== 0) return byImpact;
  const byEffort = (EFFORT_RANK[a.effort ?? ''] ?? 0) - (EFFORT_RANK[b.effort ?? ''] ?? 0); // low effort first
  if (byEffort !== 0) return byEffort;
  return (a.priority ?? Number.MAX_SAFE_INTEGER) - (b.priority ?? Number.MAX_SAFE_INTEGER);
}
